import { StoreContext } from '@roc/feature-app-core';
import { useContext } from 'react';
import { DocumentLibraryStore } from '../store/documentLibraryStore';

export const useDocumentLibraryStore = () =>
  useContext<{
    documentLibraryStoreNew: DocumentLibraryStore;
  }>(StoreContext);
